import initSiteSearch from './site-search-init';

export default () => {
  initSiteSearch();
};
